import React, { Fragment } from 'react';

export default {
  title: <Fragment>Schwarz-Gelb</Fragment>,
  duration: 'Oktober 2009 - Dezember 2013',
  startDate: new Date(2009, 9, 27),
  endDate: new Date(2013, 11, 16),
  description: 'Opposition',
  description_long: 'Die Sozialdemokraten können als Oppositionsführer wieder Kräfte sammeln. In der Eurokrise können sie einen Abwärtstrend in den Umfragen aufhalten - und legen sogar leicht zu. Dabei profitieren sie vor allem von einer zunehmenden Enttäuschung über Schwarz-Gelb.',
  items: [{
    milestone: true,
    coords: {
      x: new Date(2009, 10, 12),
      y: 20
    },
    coordsMobile: {
      x: new Date(2009, 10, 12),
      y: 15
    },
    kicker: '13. November 2009',
    title: (<h3>Sigmar Gabriel <em>(2683 Tage)</em></h3>),
    text:
      <p>
        <span className="media">
          <img src="images/chronik/08-2009-gabriel.jpg"/>
          <span className="media-sub clearfix">
            <span className="media-caption"></span>
            <span className="media-credit">picture-alliance/Sven Simon</span>
          </span>
        </span>
      Sigmar Gabriel soll der unter Merkel auf 23 Prozent kleinregierten SPD zu neuer Größe verhelfen. 
      In der Oppostion ist zumindest der Abwärtstrend vorerst gestoppt. 
      Kanzlerkandidat wird Gabriel aber nie, dafür ab 2013 Vizekanzler in der großen Koalition. 
      Und er beweist, dass der SPD-Vorsitz nicht unbedingt ein Schleudersitz sein muss. Solange wie er ist niemand seit der Wiedervereinigung SPD-Chef.
      </p>,
      additional: (<ul>
          <li><strong>Umfragehoch: </strong>33&nbsp;Prozent (Emnid) am 18. Februar 2017</li>
          <li><strong>Umfragetief: </strong>19&nbsp;Prozent (Forsa) am 25. November 2009</li>
        </ul>)
  }, {
    milestone: false,
    coords: {
      x: new Date(2013, 8, 21),
      y: 26
    },
    coordsMobile: {
      x: new Date(2013, 8, 21),
      y: 26.5
    },
    kicker: '22. September 2013',
    title: 'Deutschland wählt wieder Schwarz-Rot',
    text:
      <p>
        Bei der Bundestagswahl können die Volksparteien zulegen. Doch Merkels Union kann mit 41,5 Prozent den Abstand zur SPD vergrößern, die sich nur leicht verbessern kann (25,7). 
        Die FDP ist raus, die erstmals angetretene AfD verpasst knapp den Einzug ins Parlament. Für Schwarz-Grün ist die Zeit noch nicht reif, so wird es wieder eine Groko.
      </p>
  }]
};
